import React from 'react'
import { getImages } from '../Components/Common/const'
import HomeContact from '../Components/Home/HomeContact'

const OurService = () => {
    return (
        <>
            <section className='common-wrap d-flex align-items-center' style={{ backgroundImage: `url(${getImages('service-hero-bg.webp')})` }}>
                <div className='w-100'>
                    <div className='container'>
                        <div className='xl-title text-uppercase text-center wow reveal fadeInUp'>Service</div>
                        <div className='lg-title text-uppercase text-center fw-500 mt-3 mb-3 wow reveal fadeInUp'>Expert Certified Technicians</div>
                    </div>
                </div>
            </section>
            <section className='key-service-wrap'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-7 col-12 wow reveal fadeInUp'>
                            <div className='lg-title text-uppercase mb-3'>Key Service Highlights</div>
                            <div className='common-text mb-lg-5 mxw-580 pe-md-4'>
                                <p>With our in house ASE certified mechanic shop, we are able to inspect, diagnose and service our vehicles.  We want you to rest assured that you are buying a sound automobile.  When you purchase from Mercedeshowroom, both you and your automobile will be treated with the utmost care and attentiveness.  That’s why so many customers return to purchase their next vehicle from us.</p>
                            </div>
                            <div className='pt-4 text-md-start text-center'>
                                <a href='#' className='transparent-btn w-300 text-uppercase d-inline-block'>Schedule Service</a>
                            </div>
                        </div>
                        <div className='col-lg-5 col-12 wow reveal fadeInUp'>
                            <ul className='key-service-list mt-lg-0 mt-5'>
                                <li className='my-lg-5 my-4'>
                                    <div className='d-flex'>
                                        <div className='ksl-icon pt-2'>
                                            <img src={getImages('icon-check.svg')}/>
                                        </div>
                                        <div className='ksl-content ps-3'>
                                            <div className='lg-title text-start text-uppercase mb-2'>Routine Maintenance</div>
                                            <div className='xs-title'>Our mechanics will keep your vehicle running smoothly</div>
                                        </div>
                                    </div>
                                </li>
                                <li className='my-lg-5 my-4'>
                                    <div className='d-flex'>
                                        <div className='ksl-icon pt-2'>
                                            <img src={getImages('icon-check.svg')}/>
                                        </div>
                                        <div className='ksl-content ps-3'>
                                            <div className='lg-title text-start text-uppercase mb-2'>Repairs</div>
                                            <div className='xs-title'>We can assist with a wide variety of issues you may have</div>
                                        </div>
                                    </div>
                                </li>
                                <li className='my-lg-5 my-4'>
                                    <div className='d-flex'>
                                        <div className='ksl-icon pt-2'>
                                            <img src={getImages('icon-check.svg')}/>
                                        </div>
                                        <div className='ksl-content ps-3'>
                                            <div className='lg-title text-start text-uppercase mb-2'>Diagnostics</div>
                                            <div className='xs-title'>Our experts are top of the line troubleshooters</div>
                                        </div>
                                    </div>
                                </li>
                                <li className='my-lg-5 my-4'>
                                    <div className='d-flex'>
                                        <div className='ksl-icon pt-2'>
                                            <img src={getImages('icon-check.svg')}/>
                                        </div>
                                        <div className='ksl-content ps-3'>
                                            <div className='lg-title text-start text-uppercase mb-2'>Tire Rotations</div>
                                            <div className='xs-title'>Great preventative maintenance, we’ll have it done quickly</div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section className='featured-service-wrap'>
                <div className='container'>
                    <div className='lg-title font-3em fw-500 wow reveal fadeInUp ps-3 ps-md-0'>Featured Services</div>
                    <div className='row mt-lg-5 mlr-35'>
                        <div className='col-lg-4 col-12 mt-lg-0 mt-4 wow reveal fadeInUp'>
                            <div className='fs-box'>
                                <div className='fs-box-top'>
                                    <img src={getImages('service-f-image1.webp')} />
                                </div>
                                <div className='fs-box-bottom'>Oil Changes & Schedule <br />Maintenance</div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-12 mt-lg-0 mt-4 wow reveal fadeInUp'>
                            <div className='fs-box'>
                                <div className='fs-box-top'>
                                    <img src={getImages('service-f-image2.webp')} />
                                </div>
                                <div className='fs-box-bottom'>Collision Repair and <br />Body Work</div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-12 mt-lg-0 mt-4 wow reveal fadeInUp'>
                            <div className='fs-box'>
                                <div className='fs-box-top'>
                                    <img src={getImages('service-f-image3.webp')} />
                                </div>
                                <div className='fs-box-bottom'>Tires, Brakes & <br />Alignments</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <HomeContact />
        </>
    )
}

export default OurService